<template>
  <div :class="['uk-introduce-box', 'font-medium', showBg ? 'haveBg' : '']" v-html="content" />
</template>
<script>

export default {
  props: {
    content: {
      type: String,
      default: '',
    },
    showBg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
}

</script>
<style lang="scss" scoped>
.uk-introduce-box {
  width: 100%;
  padding: 50px 40px 40px;
  border-radius: 12px;
  font-size: 20px;
  color: var(--txt-color-lv3);
  line-height: 34px;
  background-color: #fff;
  margin-bottom: 50px;

  /deep/img {
    max-width: 100%;
  }
}

.haveBg {
  background: url('~assets/images/courses/introduceLeftTop.png') no-repeat 30px 19px, url('~assets/images/courses/introduceRightBottom.png') no-repeat calc(100% - 30px) calc(100% - 19px);
  background-size: 45px 26px, 45px 26px;
  background-color: #fff;
}
</style>
